import {useForm} from 'antd/es/form/Form';
import moment, {Moment} from 'moment';
import {useCallback, useEffect, useRef, useState} from 'react';

import {IModalOpenerComponentRef} from 'components/modal-opener-component';
import {TEntity, resetLoadedData} from 'modules/data';
import {EEntityType} from 'shared/constants/entities';
import {TStateSetter} from 'shared/types/generics';
import {showMessageFromResponse} from 'shared/utils';
import {useAppDispatch} from 'store/config/hooks';

import {sendFactorInfluenceInfoService} from '../api';

interface IFactorInfluenceInfoServiceForm {
    serviceName: string;
    reportingDate: Moment;
}

interface IUseFactorInfluenceInfoServiceModalArgs {
    selectedRows: TEntity[] | undefined;
    entityName: string;
    onSubmit?: (values: {serviceName: string; submissionDate: string}) => void;
}

export const useFactorInfluenceInfoServiceModal = ({
    selectedRows,
    entityName,
}: IUseFactorInfluenceInfoServiceModalArgs) => {
    const [form] = useForm<IFactorInfluenceInfoServiceForm>();
    const modalRef = useRef<IModalOpenerComponentRef>(null);
    const [isOpen, setIsOpen] = useState(false);
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (isOpen) {
            const selectedRow = selectedRows?.[0] as TEntity;

            if (!selectedRow?.reportingDate) {
                return;
            }

            form.setFieldsValue({
                serviceName:
                    'Сервис отправки сведений о макроэкономических факторах (санкционных ограничениях), влияющих на деятельность компании',
                reportingDate: moment(selectedRow?.reportingDate as string),
            });
        }
    }, [isOpen, form, selectedRows]);

    const handleFinish = useCallback(async () => {
        try {
            const response = await sendFactorInfluenceInfoService({id: selectedRows?.[0]?.id as string});
            showMessageFromResponse(response);
        } catch (error) {
            showMessageFromResponse({response: error?.response, isError: true});
        }

        modalRef.current?.setIsModalOpen(false);
        form.resetFields();
        dispatch(resetLoadedData(entityName, EEntityType.TABLE));
    }, [form, modalRef, selectedRows, entityName, dispatch]);

    const handleCloseModal = useCallback(
        (setIsModalOpen: TStateSetter<boolean>) => {
            form.resetFields();
            setIsModalOpen(false);
        },
        [form]
    );

    return {modalRef, isOpen, form, setIsOpen, handleCloseModal, handleFinish};
};
